const ResourcesPage = () => {
  return (
    <iframe
      title={"Resources"}
      src={"https://baptize.org/engage"}
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        border: "none",
      }}
      allowFullScreen
    />
  );
};

export default ResourcesPage;
